module.exports = __webpack_public_path__ + "img/knsu_gallery10.b730e017.jpg";